
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 2.75A2.75 2.75 0 003.25 5.5v9.2c0 .73.29 1.429.805 1.945a.75.75 0 001.061-1.061 1.25 1.25 0 01-.366-.884V5.5A1.25 1.25 0 016 4.25h8c.332 0 .65.132.884.366a.75.75 0 101.06-1.06A2.75 2.75 0 0014 2.75H6zM8.75 9.5c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v9.2c0 .69-.56 1.25-1.25 1.25h-8c-.69 0-1.25-.56-1.25-1.25V9.5zM10 6.75A2.75 2.75 0 007.25 9.5v9.2A2.75 2.75 0 0010 21.45h8a2.75 2.75 0 002.75-2.75V9.5A2.75 2.75 0 0018 6.75h-8z"}})])
          )
        }
      }
    